import { MenuItem, Select, Checkbox, Button, Divider } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import CombinedPopup from '../../components/Popups/CombinedPopup';
import { applyCouponCode, deletePaymentIntent, getChallenges, stripePaymentInitV4 } from '../../store/reducers/paymentReducer';
import { addCurrentAccount, getUserProfile } from '../../store/reducers/userProfileReducer';
import { axiosInstance } from '../../Axios';
import { apiConfig } from '../../store/reducers/tokenReducer';

const PaymentForm = () => {

    const challenges = useSelector((state) => state.payments.challenges);
    const ACCtoken = useSelector((state) => state.ACCtoken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState({
        challenge_id: '',
        name: '',
        pwd: '',
        leverage: 0,
        challenge: '',
    });
    const [accountBalance, setAccountBalance] = useState(false);
    const [fundingEval, setFundingEval] = useState(false);
    const [FreeTrial, setFreeTrial] = useState(false);
    const [checked, setChecked] = useState(false);
    const [coupon, setCoupon] = useState({
        value: '',
        error: '',
        loading: false
    });
    const [EAs, setEAs] = useState(false);
    const [checkout, setCheckout] =useState({
        price: 0,
        discount: 0,
        final_price: 0
    })

    const updateData = (k,v) => setData(prevState=>({...prevState, [k]:v}));


    // Popup states
    const [showPopup, setShowPopup] = useState(false);
    const [combinedPUHead, setCombinedPUHead] = useState("");
    const [combinedPUBody, setCombinedPUBody] = useState("");
    const [popUpType, setPopUpType] = useState("");


    const params = useParams();

    useEffect(()=>{dispatch(getChallenges())},[dispatch])

    useEffect(() => {
        if(params.id){
            challenges && Object.keys(challenges).forEach(plan_type=>{
                challenges[plan_type].forEach((challenge) => {
                    if(String(challenge.id) === String(params.id)){
                        setFundingEval(challenge.plan_type === "Alpha pro"? "Alpha Pro": challenge.plan_type);
                        setAccountBalance(challenge.account_balance)
                        updateData('leverage', Number(challenge.leverage));
                        updateData('challenge_id', challenge.id);
                        updateData('challenge', challenge.id);
                        return 
                    }
                })
            })
        }
    }, [params.id, challenges, dispatch]);
    
    useEffect(()=>{
        if (fundingEval && accountBalance && challenges){
                const plan = challenges[fundingEval].filter(challenge => {
                    if(challenge.account_balance === accountBalance){
                        return true
                    }
                    return false;
                });

                if(plan.length===1){
                    updateData('leverage', Number(plan[0].leverage));
                    updateData('challenge_id', plan[0].id);
                    updateData('challenge', plan[0].id);
                }else{
                    updateData('challenge_id', '');
                    updateData('challenge', '');
                }
        }
    },[fundingEval, accountBalance, challenges])

    useEffect(()=>{
        validateCouponCode();
    },[data.challenge_id])


    const handleFinalPayment = (e) => {
        e.preventDefault();
        if (checked === false) {
          setShowPopup(true);
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody("Please accept the terms and conditions");
          setPopUpType("error");
          return;
        }
        if (!data.name) {
          setShowPopup(true);
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody("Please enter an account name!");
          setPopUpType("error");
          return;
        }

        if (!data.challenge_id) {
            setShowPopup(true);
            setCombinedPUHead("Oh snap!");
            setCombinedPUBody("Please select a plan and balance!");
            setPopUpType("error");
            return;
        }

        if (!data.pwd) {
          setShowPopup(true);
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody("Please enter a valid account password!");
          setPopUpType("error");
          return;
        }
        if (data.pwd.length < 8) {
          setShowPopup(true);
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody("The minimum password length is 8 characters");
          setPopUpType("error");
          return;
        }
        
          const acc_creation_payload = {
            name: data.name,
            pwd: data.pwd,
            pwdInvestor: data.pwd,
            group: "ACGd\\demo ACG",
            leverage: data.leverage,
            challenge: data.challenge,
          };
          const freetrial_acc_payload = {
            challenge: data.challenge,
          }
          const payload = {
            challenge_id: data.challenge_id,
            success_url: `${window.location.origin}/challenge/payment/success/`,
            cancel_url: `${window.location.origin}/challenge/payment/cancelled/`,
          };
          if(coupon.value && !coupon.loading) payload['coupon'] = coupon.value;
    
          if (FreeTrial) {
            if (freetrial_acc_payload) {
              setShowPopup(true);
              setCombinedPUHead("Creating Account");
              setCombinedPUBody("Please wait...");
              setPopUpType("success");
              axiosInstance
                .post(
                  "v2/create/free-trial/",
                  freetrial_acc_payload,
                  apiConfig()
                )
                .then((res) => {
                  if (res.data.success) {
                    setShowPopup(true);
                    setCombinedPUHead("Woo hoo !");
                    setCombinedPUBody("Account created successfully!!");
                    setPopUpType("success");
                    dispatch(deletePaymentIntent());
                    dispatch(getUserProfile()).then(data => {
                      dispatch(addCurrentAccount(res.data.login))
                      navigate("/AccountMetric");
                    });
                  }
                  
                })
                .catch((error) => {
                  console.log({...error})
                  if(error.response.data.message){
                    setShowPopup(true);
                    setCombinedPUHead("Oh snap!");
                    setCombinedPUBody(error.response.data.message);
                    setPopUpType("error");
                  }else{
                    setShowPopup(true);
                    setCombinedPUHead("Oh snap!");
                    setCombinedPUBody("Something went wrong");
                    setPopUpType("error");
                  }
                });
            }
          } else {
            acc_creation_payload['EAs'] = EAs;
            dispatch(stripePaymentInitV4(payload, acc_creation_payload)).then(res=>{
                alert("After payment please click on 'Continue to merchant' for the trading account to be created.")
                window.location.href = res.url;
            });
          }
        
    
    };

    const validateCouponCode = ()=>{
        setCoupon(prevState=>({...prevState, loading:true}));
        if (!data.challenge_id) return;
        const coupon_code = coupon.value?coupon.value:null;

        dispatch(applyCouponCode(data.challenge_id, coupon_code)).then(res=>{
            setCoupon(prevState=>({...prevState, error:''}));
            setCoupon(prevState=>({...prevState, loading:false}));
            setCheckout(prev=>({
                price: res.actual_price,
                discount: res.discount,
                final_price: res.discounted_price
            }))
            setFreeTrial(res.discounted_price===0);
            if(res.data.coupon) setCoupon(res.data.coupon);
        }).catch(error=>{
            // setCoupon(prevState=>({...prevState, loading:false}));
            setCoupon(prevState=>({...prevState, error:error?.detail}));
        })
    }

    return (
        <div className="FundingEvaluationPaymentMAIN-R">
            <CombinedPopup
                type={popUpType}
                trigger={showPopup}
                setTrigger={setShowPopup}
                head={combinedPUHead}
                subhead={combinedPUBody}
            />
            <div className="headT">Summary</div>
            <div className="FundingEvaluationPaymentMAIN-R-BTM">
            <div className="DpboxCon-Btm-tcon-editcon">
                <div className="DpboxCon-Btm-itm-l">Account name</div>
                <input
                className="DpboxCon-Btm-input"
                type="text"
                value={data.name}
                onChange={(e) => updateData('name',e.target.value)}
                />
            </div>
            <div className="DpboxCon-Btm-tcon-editcon">
                <div className="DpboxCon-Btm-itm-l">Account Password</div>
                <input
                className="DpboxCon-Btm-input"
                type="text"
                value={data.pwd}
                onChange={(e) => updateData('pwd', e.target.value)}
                />
            </div>
            <div className="DpboxCon-Btm-tcon-editcon">
                <div className="DpboxCon-Btm-itm-l">Enter coupon:</div>
                <input
                    className="DpboxCon-Btm-input"
                    type="text"
                    value={coupon.value}
                    onBlur={(e) => validateCouponCode()}
                    onChange={(e) => setCoupon(prevState=>({...prevState, value: e.target.value}))}
                    style={coupon.error ? { border: "2px solid #fd2d2d" } : {}}
                />
                {coupon.error ? (
                <small
                    style={
                    coupon.error
                        ? { color: "#fd2d2d", textAlign: "left", float: "left" }
                        : {}
                    }
                >
                    Invalid coupon
                </small>
                ) : (
                false
                )}
            </div>
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Account Balance</div>
                <div className="itm-r">
                <Select
                    id="accountBalance"
                    className="feval-input-select"
                    value={accountBalance}
                    onChange={(e)=>setAccountBalance(e.target.value)}
                >
                    {challenges &&
                    Object.keys(challenges).length &&
                    fundingEval &&
                    challenges[fundingEval] &&
                    challenges[fundingEval].map((challenge, i) => {
                        const { account_balance } = challenge;
                        return (
                        <MenuItem key={i} value={account_balance}>
                            {account_balance}
                        </MenuItem>
                        );
                    })}
                </Select>
                </div>
            </div>
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Funding Evaluation</div>
                <div className="itm-r">
                <Select
                    id="FundingEval"
                    className="feval-input-select"
                    value={fundingEval}
                    onChange={(e)=>setFundingEval(e.target.value === "Alpha pro" ? "Alpha Pro" : e.target.value)}
                >
                    {challenges &&
                    Object.keys(challenges).map((challenge, i) => {
                        return (
                        <MenuItem key={i} value={challenge}>
                            {challenge}
                        </MenuItem>
                        );
                    })}
                </Select>
                </div>
            </div>
            {!FreeTrial?
            (<div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Expert Advisor</div>
                <div className="itm-r">
                <Checkbox
                    checked={EAs}
                    onChange={(e)=>setEAs(!EAs)}
                />
                </div>
            </div>):false}
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Provider</div>
                <div className="itm-r">
                <p>Alpha Capital</p>
                </div>
            </div>
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Platform</div>
                <div className="itm-r">
                <p>Alpha Capital</p>
                </div>
            </div>
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Price</div>
                <div className="itm-r">
                <p>{checkout.price}</p>
                </div>
            </div>
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l">Discount</div>
                <div className="itm-r">
                <p>{checkout.discount}</p>
                </div>
            </div>
            <Divider sx={{background: 'white'}}/>
            <div className="FundingEvaluationPaymentMAIN-R-itm">
                <div className="itm-l bl">To be paid</div>
                <div className="itm-r bl">
                <p>{Number(checkout.final_price)}</p>
                </div>
            </div>
            </div>

            <div className="FundingEvaluationPaymentMAIN-R-under">
            <div className="FundingEvaluationPaymentMAIN-R-under-top">
                <Checkbox
                // className='cbmi'
                checked={checked}
                onChange={(e)=>setChecked(e.target.checked)}
                // inputProps={{ 'aria-label': 'controlled' }}
                />
                <p>
                I declare that I have read and agree with
                <span>Cancellation</span> &<span>Refund Policy</span>
                </p>
            </div>
            <div className="FundingEvaluationPaymentMAIN-R-under-btm">
                <Button disabled={coupon.value?coupon.loading:false} className="mbb-20" onClick={handleFinalPayment}>
                {FreeTrial ? "Create Account" : `Pay ${Number(checkout.final_price)} USD`}
                </Button>
            </div>
            </div>
        </div>
    )
}

export default PaymentForm
